import { QueryClient } from '@tanstack/react-query';
import { bindQueryClientToSession, type SessionLifecycle } from '@mbbe/config';
import { adminMutationActivity } from './chunkRecovery';
import { adminSession } from './session';

/**
 * Admin QueryClient scoped to the active session: sign-out, account switch,
 * role change or provider unmount cancels in-flight queries and drops every
 * cached query and mutation before the next account renders.
 */
export function createAdminQueryClient(session: SessionLifecycle = adminSession): QueryClient {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
  bindQueryClientToSession(session, queryClient);
  // An in-flight mutation keeps blocking a stale-deployment reload even after its screen was replaced.
  adminMutationActivity.attach({
    isPending: () => queryClient.isMutating() > 0,
    subscribe: (listener) => queryClient.getMutationCache().subscribe(() => listener()),
  });
  return queryClient;
}
